export default __webpack_public_path__ + "static/sowos_animated-a054e91ac5e6c598408bd54e14bc1195.gif";